module.exports = __webpack_public_path__ + "static/toggle-b7d0d79d8b36801620ae36aa1a97fd06.gif";